import React, { useEffect, useState } from "react";
import AddressComponent from "../../components/AddressComponent";
import Title from "../../components/Title";
import LockIcon from "../../assets/padlock.svg";
import notify from "../../components/UI/toast";
import {
  addAddress,
  deleteAddress,
  getAddresses,
  editAddresses,
} from "../../components/AddressComponent/services/addressService";
import { useUserData } from "../../hooks/UserContext";
import { Row, Container, Col } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import PersonalAddressList from "../../components/AddressComponent/personalAddressList";
import {
  isFixedAddress,
  SAFRA_FIXED_ADDRESS_MESSAGE,
  extractSavedAddressFromResponse,
  mergeSavedAddressMain,
} from "../../components/AddressComponent/addressUtils";
import { capitalizeFirstLetter } from "../../extension/string.ts";
import ModalApp from "../../components/ModalApp";
import { cardsApi } from "../OrderResumePag/_services/api";
import mocks from "../../mocks/list-address.json";
import { Text, RegisteredCards, PageWrap } from "./styles";
import { RegisterNewCard } from "./_components/RegisterNewCard";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";

export default function MyAccount() {
  const screenName = useScreenTracking();
  const [Loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [address, setAddress] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [open, setOpen] = useState(false);
  const [refreshCards, setRefreshCards] = useState();
  const jwt = useUserData();
  const customer_address = jwt?.addressesData || [];
  const dataUser = jwt?.userData.data;

  async function handleEndereco(address) {
    let result = null;
    address["customerUuid"] = dataUser.uuid;

    if (isFixedAddress(address)) {
      notify(SAFRA_FIXED_ADDRESS_MESSAGE, "info");
      return;
    }

    try {
      if (address.uuid) {
        result = await editAddresses(address);
      } else {
        result = await addAddress(address);
      }

      if (result.status !== 200) {
        const errorMessage = result.data?.message || "Erro ao salvar endereço";
        notify(errorMessage, "error");
        return;
      }

      const successMessage = result.data?.message || "Endereço salvo com sucesso";
      notify(successMessage, "success");

      trackClick({
        title: address.uuid ? "salvar" : "adicionar",
        contentType: address.uuid ? "atualizar-dados-do-endereco" : "cadastrar-novo-endereco",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });
      
      jwt.setUpdateAddresses(new Date());
      
      // Atualizar a listagem de endereços
      const updatedAddresses = await getAddresses();
      const savedAddress = extractSavedAddressFromResponse(result);
      const targetUuid = address.uuid || savedAddress?.uuid;
      const savedMain = savedAddress?.main ?? address.main;

      setAddresses(
        mergeSavedAddressMain(updatedAddresses, targetUuid, savedMain),
      );
      setOpen(false);

      return true;

    } catch (error) {
      console.error("Erro ao salvar endereço:", error);
      const errorMessage = error.response?.data?.message || "Erro ao salvar endereço";
      notify(errorMessage, "error");
    }
  }

  async function onClickDelAddress(uuidAddress) {
    const targetAddress = addresses.find((item) => item.uuid === uuidAddress);

    if (isFixedAddress(targetAddress)) {
      notify(SAFRA_FIXED_ADDRESS_MESSAGE, "info");
      return;
    }

    var message = "";
    var type = "success";
    
    try {
      const response = await deleteAddress(uuidAddress);
      message = response.message;

      trackClick({
        title: "excluir",
        contentType: "atualizar-dados-do-endereco",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });
      
      // Atualizar a listagem de endereços após deletar
      const updatedAddresses = await getAddresses();
      setAddresses(updatedAddresses);
    } catch (error) {
      message = error.message;
      type = "error";
    } finally {
      notify(message, type);
      jwt.setUpdateAddresses(new Date());
    }
  }

  useEffect(() => {
    if (dataUser) {
      const fetchData = async () => {
        const cardResponse = await getCard();
        const cards = cardResponse || [];
        setCards(() => [...cards]);

        const userAddresses = await getAddresses();
        setAddresses(userAddresses);

        setLoading(false);
      };
      fetchData();
    }
  }, [dataUser, Loading, refreshCards]);

  function adicionarEndereco() {
    trackClick({
      title: "adicionar",
      contentType: "enderecos-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });
    
    setAddress({});
    setOpen(true);
  }

  async function getCard() {
    try {
      const { data, status } = await cardsApi.get(
        `/v1/customer/card`
      );

      if (status !== 200) {
        notify("Erro ao obter os dados do cartão", "error");
        return;
      }

      return data.data;
    } catch (err) {
      console.error(err);
      notify("Erro ao obter os dados do cartão.", "error");
    }
  }

  return (
    !Loading && (
      <>
        <ModalApp show={open} handleModal={() => {
          trackClick({
            title: "fechar-modal",
            contentType: "cadastrar-novo-endereco",
            screenName,
            tagId: tagIdFromLegacySuffix("07"),
          });
          setOpen(false);
        }}>
          <AddressComponent
            onConfirm={handleEndereco}
            onCancel={() => setOpen(false)}
            address={address}
          />
        </ModalApp>
        <div className="wl-page">
          <PageWrap>
          <Container>
            <Title titleClass="mt-3" label="Minha Conta" />
            <div className="group-disabled-color color-opacty-60 mt-5">
              <div className="input-group mb-5">
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="Nome"
                  value={capitalizeFirstLetter(dataUser.nome)}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group mb-5">
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="Sobrenome"
                  value={capitalizeFirstLetter(dataUser.sobrenome)}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group mb-5">
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="CPF"
                  value={dataUser.cpf}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group mb-5">
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="(99) 9 9999-9999"
                  value={dataUser.telefone ?? ''}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group mb-5">
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="teste@mail.com"
                  value={dataUser.email}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>
            </div>
            <Text className="mt-5">
              <p className="font-wl- text-mg color-text-dark mb-4">
                Endereços cadastrados
              </p>
              <PersonalAddressList
                addresses={Array.isArray(addresses) ? addresses : []}
                onClickDelAddress={onClickDelAddress}
                setAddress={setAddress}
                setOpen={setOpen}
                open={open}
                address={address}
                handleEndereco={handleEndereco}
                screenName={screenName}
              />
            </Text>
            <Row>
              <Col className="my-5">
                <button
                  className="btn-outline-wl px-4 py-2 text-xs font-wl-700"
                  style={{ width: "fit-content" }}
                  onClick={adicionarEndereco}
                >
                  ADICIONAR ENDEREÇO
                </button>
              </Col>
            </Row>
            <RegisteredCards className="mt-4">
              <p className="font-wl-600 text-mg color-text-dark mb-4">
                Cartões cadastrados
              </p>
              <RegisterNewCard
                addresses={Array.isArray(addresses) ? addresses : [addresses]}
                cards={cards}
                setCards={setCards}
                setRefreshCards={setRefreshCards}
              />
            </RegisteredCards>
          </Container>
          </PageWrap>
        </div>
      </>
    )
  );
}
